import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import { useTheme } from "../../context/ThemeContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faDownload,
  faSatellite,
  faQuestion,
  faTowerBroadcast,
  faAddressCard,
  faSun,
  faMoon,
  faCogs
} from '@fortawesome/free-solid-svg-icons';

function Header() {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* الشعار */}
        <div className={styles.logo}>
          <Link to="/" aria-label="Go to homepage">
            <img
              src="/logo.png"
              alt="Zoon Sat Logo"
              className={styles.logoImg}
            />
          </Link>
        </div>

        {/* القائمة الرئيسية */}
        <nav className={styles.mainNav} aria-label="Primary navigation">
          <ul>
            {[
              { to: "/", icon: faHouse },
              { to: "/downloader", icon: faDownload },
              { to: "/software", icon: faCogs },
              { to: "/frequencies", icon: faSatellite },
              { to: "/live", icon: faTowerBroadcast },
              { to: "/faq", icon: faQuestion},
              { to: "/about", icon: faAddressCard},
            ].map(({ to, icon, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={`${styles.navLink} ${location.pathname === to ? styles.active : ""}`}
                  aria-current={location.pathname === to ? "page" : undefined}
                  title={label}
                >
                  <FontAwesomeIcon icon={icon} />
                  <span className={styles.linkText}>{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* زر تبديل الوضع */}
        <button
          onClick={toggleTheme}
          className={styles.themeToggleBtn}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          type="button"
        >
          <FontAwesomeIcon icon={theme === "dark" ? faSun : faMoon} />
        </button>
      </div>
    </header>
  );
}

export default Header;
